export enum FeatureSlug {
  RecurringInvoices = "recurring_invoices",
  Forms = "forms",
  AllowInvoiceAmountOverrides = "allow_invoice_amount_overrides",
  ClientContactTypes = "client_contact_types",
  AuditLogs = "audit_logs",
}

export interface Feature {
  name: string;
  slug: FeatureSlug;
  limit: number;
}

export interface FeaturePacks {
  name: string;
  slug: string;
  features: {
    data: Feature[];
  };
}

export interface OrganizationRole {
  code: string;
  slug: string;
  name: string;
  is_system: boolean;
  permissions: string[];
}

export interface Organization {
  code: string;
  name: string;
  sandbox: boolean;
  tag_line: string;
  email: string;
  phone: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  status: "active" | "inactive";
  role: OrganizationRole;
  joined_at: string;
  image_url: string;
  stripe_account_id: string | null;
  settings: {
    data: {
      allow_partial_payment_for_invoices: boolean;
      pass_on_credit_card_fee: boolean;
      first_invoice_reminder: string;
      second_invoice_reminder: string;
      third_invoice_reminder: string;
      send_first_reminder: boolean;
      send_second_reminder: boolean;
      send_third_reminder: boolean;
      late_payment_surcharge: string | null;
      primary_interac_email_address: string | null;
      invoice_logo_url: string | null;
      timezone: string;
      working_days: number[];
      daily_prompt_time: string | null;
      daily_slack_prompt_enabled: boolean;
      rate_lock_policy: "at_invoice" | "at_creation" | "none";
      invoice_number_start: number;
      invoice_number_prefix: string | null;
      receipt_number_start: number;
      receipt_number_prefix: string | null;
      default_invoice_terms: string | null;
      compliance_company_name: string | null;
      compliance_address_line1: string | null;
      compliance_address_line2: string | null;
      compliance_city: string | null;
      compliance_region: string | null;
      compliance_postal_code: string | null;
      compliance_country: string | null;
    };
  };
  feature_packs: {
    data: FeaturePacks[];
  };
  direct_features: {
    data: Feature[];
  };
  created_at: string;
  updated_at: string;
}
